import { schAloftPrice } from '@aloft/toolkit-shared';

import { z } from 'zod';

export const schReconciliationSheetForm = z.object({
  totalCostToCure: schAloftPrice.optional(),
  opinionOfMarketValue: schAloftPrice.optional(),
  reconciliationCommentary: z.string().optional(),
});
export type ReconciliationSheetFormOutput = z.infer<typeof schReconciliationSheetForm>;
export type ReconciliationSheetForm = typeof schReconciliationSheetForm;
